// viewport.service.ts
import {ElementRef, Injectable} from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class ViewportService {
  private isIOS = /iPad|iPhone|iPod/.test(navigator.userAgent);
  private scrollerDiv?: ElementRef;
  private useNativeScroll = false;

  setUpViewport(elem: ElementRef, nativeScroll: boolean) {
    this.scrollerDiv = elem;
    this.useNativeScroll = nativeScroll;
  }

  scrollToBottom(): number {
    if (this.useNativeScroll) {
      const sc = document.documentElement.scrollHeight;
      window.scrollTo({ top: sc, behavior: 'instant' });
      return sc;
    } else if (this.scrollerDiv?.nativeElement) {
      const sc = this.scrollerDiv.nativeElement.scrollHeight;
      this.scrollerDiv.nativeElement.scrollTo({ top: sc, behavior: 'instant' });
      return sc;
    }
    return 0;
  }

  scrollToTop(){
    if (this.useNativeScroll) {
      window.scrollTo({ top: 0, behavior: 'instant' });
    } else if (this.scrollerDiv?.nativeElement) {
      this.scrollerDiv.nativeElement.scrollTo({ top: 0, behavior: 'instant' });
    }
  }

  scrollHeight(): number {
    return this.useNativeScroll
      ? document.documentElement.scrollHeight
      : (this.scrollerDiv?.nativeElement?.scrollHeight || 0);
  }

  killMomentumAndScrollToTop() {
    if (this.useNativeScroll) {
      this.scrollToTop();
    } else if (this.scrollerDiv?.nativeElement) {

      // Kill momentum on ios
      this.scrollerDiv.nativeElement.style.webkitOverflowScrolling = 'auto';

      // Force reflow
      void this.scrollerDiv.nativeElement.offsetHeight;

      setTimeout(() => {
        // Scroll to top
        // @ts-ignore
        this.scrollerDiv.nativeElement.scrollTo({ top: 0, behavior: 'instant' });

        // Re-enable smooth scrolling
        // @ts-ignore
        this.scrollerDiv.nativeElement.style.webkitOverflowScrolling = 'touch';
      }, 10);

    }

  }
}
